import { render } from "./OptIn.vue?vue&type=template&id=0e1d54ab&scoped=true&ts=true"
import script from "./OptIn.ts?vue&type=script&lang=ts&external"
export * from "./OptIn.ts?vue&type=script&lang=ts&external"

import "./OptIn.scss?vue&type=style&index=0&id=0e1d54ab&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e1d54ab"]])

export default __exports__